import dayjs from 'dayjs';

import styles from './styles.module.less';

const AvatarMask = () => {
  const targetTime = '2024-12-26 00:00:00';
  if (dayjs().isAfter(dayjs(targetTime))) return null;
  return <div className={styles.avatar}></div>;
};

export default AvatarMask;
